import {ReactNode} from 'react';

interface FieldGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  label?: ReactNode;
  labelFor?: string;
}

export const FieldGroup = ({children, label, labelFor, ...rest}: FieldGroupProps) => {
  return (
    <div className="flex flex-col gap-1.5" {...rest}>
      {label && (
        <label htmlFor={labelFor} className="w-full text-sm text-text-secondary">
          {label}
        </label>
      )}
      {children}
    </div>
  );
};
